import { Offer } from '@wwt/entities/search-response'

import { getFullRoomId } from '@/entities/offer'
import { assert } from '@/shared/lib/assert'

import { DislikeTypes } from '../config/dislikeQueryKeys'

const removeOfferFromDisliked = (
	saved: DislikeTypes['all'] | undefined,
	offer: Offer
) => {
	assert(
		saved !== undefined,
		'Saved dislikes is undefined on remove offer from disliked'
	)
	assert(
		saved.disliked !== undefined,
		'Dislikes field in saved dislikes is undefined on remove offer from disliked'
	)

	const fullRoomId = getFullRoomId(offer)

	return { disliked: saved.disliked.filter(id => id !== fullRoomId) }
}

const addOfferToDisliked = (
	saved: DislikeTypes['all'] | undefined,
	offer: Offer
) => {
	assert(
		saved !== undefined,
		'Saved dislikes is undefined on add offer to disliked'
	)
	assert(
		saved.disliked !== undefined,
		'Dislikes field in saved dislikes is undefined on add offer to disliked'
	)

	const fullRoomId = getFullRoomId(offer)

	return { disliked: [...saved.disliked, fullRoomId] }
}

export const DislikeMutationUtils = {
	removeOfferFromDisliked,
	addOfferToDisliked
}
